export const createFileHash = async (file: File): Promise<string> => {
  const arrayBuffer = await crypto.subtle.digest("sha-256", await file.arrayBuffer());

  const uint8Array = new Uint8Array(arrayBuffer);
  const hash = Array.from(uint8Array)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return hash;
};
